import { useEffect } from "react";
import { motion } from "framer-motion";

// Full-screen celebratory burst for 180s and checkouts.
export default function Burst({ label, sub, color = "#FFCC00", onDone }) {
  useEffect(() => {
    const t = setTimeout(() => onDone && onDone(), 1500);
    return () => clearTimeout(t);
  }, [onDone]);

  const particles = Array.from({ length: 20 });

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[60] flex items-center justify-center pointer-events-none"
      data-testid="fx-burst"
    >
      <div className="absolute inset-0 bg-black/40" />
      {particles.map((_, i) => {
        const angle = (i / particles.length) * Math.PI * 2;
        const dist = 220 + Math.random() * 160;
        return (
          <motion.div
            key={i}
            initial={{ x: 0, y: 0, opacity: 1, scale: 1 }}
            animate={{
              x: Math.cos(angle) * dist,
              y: Math.sin(angle) * dist,
              opacity: 0,
              scale: 0.4,
            }}
            transition={{ duration: 1.1, ease: "easeOut" }}
            className="absolute w-3 h-3 rounded-sm"
            style={{ backgroundColor: i % 2 ? color : "#ffffff" }}
          />
        );
      })}
      <motion.div
        initial={{ scale: 0.3, rotate: -12, opacity: 0 }}
        animate={{ scale: 1, rotate: 0, opacity: 1 }}
        transition={{ type: "spring", stiffness: 260, damping: 14 }}
        className="relative text-center"
      >
        <div
          className="font-display font-black uppercase leading-none tracking-tighter"
          style={{ color, fontSize: "7rem", textShadow: "0 0 40px rgba(0,0,0,0.6)" }}
        >
          {label}
        </div>
        {sub && (
          <div className="font-display text-3xl font-bold text-white uppercase tracking-wide mt-1">
            {sub}
          </div>
        )}
      </motion.div>
    </motion.div>
  );
}
